import { TrialSignupApp } from './app.module';
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
bootstrapAppModule(TrialSignupApp);
